import { is } from '@convenia/helpers'
import { configure } from 'vee-validate-next'
import { all as libRules } from '@vee-validate/rules'

import { extend } from '../helpers'

export const REQUIRED_MESSAGE = 'O campo é obrigatório.'
export const INVALID_MESSAGE = 'O campo é inválido.'

configure({
  generateMessage: (ctx) => {
    if (ctx.rule.name === 'required') {
      return REQUIRED_MESSAGE
    }

    return INVALID_MESSAGE
  }
})

const isNullOrUndefined = value => value === null || value === undefined

const isEmptyArray = value => Array.isArray(value) && value.length === 0

const resolveAllowFalse = params => {
  if (Array.isArray(params)) return params[0] ?? true
  if (is(params, 'Object')) return params.allowFalse ?? true
  return params !== false
}

Object.keys(libRules)
  .filter(rule => rule !== 'required')
  .forEach(rule => extend(rule, libRules[rule]))

// Replicates vee-validate vue 2 behavior to not break the validation API
extend('required', (value, params) => {
  if (isNullOrUndefined(value) || isEmptyArray(value)) return false

  if (value === false) return resolveAllowFalse(params)

  return !!String(value).trim().length
}, { skipIfEmpty: false })
